import GenericDB from './generic-db';

export default class IntegrationCacheDB extends GenericDB {
  constructor() {
    super('integrationCache');
  }

  // Here you can extend IntegrationCacheDB with custom methods
}
